// Tara clientului dupa IP (Shopify), o singura cerere pe pagina. UE + UK = "eu" (TVA inclus, garantie legala,
// fara extra-uri bifate din start). Folosita de spark-product.js (caseta UE) si de cos (Shipping Protection).
window.SPARK_EU = 'AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE GB'.split(' ');
window.sparkCountry = window.sparkCountry || fetch('/browsing_context_suggestions.json')
  .then(function (r) { return r.json(); })
  .then(function (d) { return (d && d.detected_values && d.detected_values.country && d.detected_values.country.handle) || null; })
  .catch(function () { return null; });

(function () {
  // Timer cos: porneste la prima deschidere a paginii si continua intre pagini (sessionStorage).
  function tick() {
    var el = document.querySelector('[data-spark-timer]');
    if (!el) return;
    var total = +el.dataset.sparkTimer, end;
    try { end = +sessionStorage.getItem('sparkTimerEnd'); } catch (e) {}
    var now = Date.now();
    if (!end || end < now) { end = now + total * 1000; try { sessionStorage.setItem('sparkTimerEnd', end); } catch (e) {} }
    var left = Math.max(0, Math.round((end - now) / 1000));
    el.textContent = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
  }
  setInterval(tick, 1000); tick();
  // Cos: comutatoare pentru upsell si Shipping Protection (snippets/spark-cart-extras.liquid)
  var busy = false;
  function render(res) {
    var drawer = document.querySelector('cart-drawer');
    if (res && res.sections && drawer && drawer.renderContents) {
      drawer.renderContents(res);
      if (typeof res.item_count === 'number') drawer.classList.toggle('is-empty', res.item_count === 0);
    }
    return res;
  }
  function cartPost(url, body) {
    body.sections = 'cart-drawer,cart-icon-bubble';
    body.sections_url = window.location.pathname;
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + url, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(render);
  }
  function toggle(input, on) {
    if (busy) return Promise.resolve();
    busy = true;
    var kind = input.dataset.sparkToggle, props = {};
    props['_spark_' + kind] = '1';
    var req = on
      ? cartPost('cart/add.js', { items: [{ id: +input.dataset.variant, quantity: 1, properties: props }] })
      : cartPost('cart/change.js', { id: input.dataset.key, quantity: 0 });
    return req.catch(function () { input.checked = !on; }).finally(function () { busy = false; });
  }
  // captura: comutatorul nu mai ajunge la cart-items din Dawn (altfel il ia drept camp de cantitate si arata o eroare)
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-spark-toggle]');
    if (!input) return;
    e.stopPropagation();
    if (input.dataset.sparkToggle === 'protect') {
      try { input.checked ? sessionStorage.removeItem('spark-prot-off') : sessionStorage.setItem('spark-prot-off', '1'); } catch (er) {}
    }
    toggle(input, input.checked);
  }, true);

  // Stergere cu confirmare: primul click pe cosul de gunoi arata un buton rosu "Remove", al doilea sterge
  document.addEventListener('click', function (e) {
    var rb = e.target.closest && e.target.closest('#CartDrawer cart-remove-button');
    if (!rb || rb.dataset.armed === '1') return;
    e.preventDefault();
    e.stopPropagation();
    var row = rb.closest('.cart-item');
    rb.dataset.armed = '1';
    if (row) row.classList.add('spark-arm');
    setTimeout(function () { rb.dataset.armed = ''; if (row) row.classList.remove('spark-arm'); }, 4000);
  }, true);

  // Dupa fiecare schimbare in cos: daca nu mai e niciun produs principal, scoate si upsell-urile si protectia
  // (cosul ramane gol, cu buton spre prima pagina); altfel pune protectia daca e pornita din start.
  function cartCheck() {
    if (busy) return;
    var mk = document.querySelector('[data-spark-cart]');
    if (mk && +mk.dataset.main === 0 && mk.dataset.extra) {
      var updates = {};
      mk.dataset.extra.split(',').filter(Boolean).forEach(function (k) { updates[k] = 0; });
      busy = true;
      cartPost('cart/update.js', { updates: updates }).finally(function () { busy = false; });
      return;
    }
    var p = document.querySelector('[data-spark-toggle="protect"]');
    if (!p) return;
    var off = false;
    try { off = sessionStorage.getItem('spark-prot-off') === '1'; } catch (er) {}
    if (+p.dataset.others > 0 && !p.checked && p.dataset.default === 'true' && !off) {
      // UE + UK: niciodata bifat din start (Directiva 2011/83 art. 22, UK CCR reg. 40)
      window.sparkCountry.then(function (cc) {
        if (!cc || window.SPARK_EU.indexOf(cc) > -1) return;
        if (!p.checked && !busy) toggle(p, true);
      });
    }
  }
  var cd = document.getElementById('CartDrawer'), t;
  if (cd) {
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(cartCheck, 250); })
      .observe(cd, { childList: true, subtree: true });
    cartCheck();
  }

  // Buton urcare
  var b = document.querySelector('.spark-top');
  if (b) {
    window.addEventListener('scroll', function () {
      b.classList.toggle('is-on', window.scrollY > 800);
      // jos de tot, butonul urca peste randul cu platile, ca sa nu acopere politicile / Cookie preferences
      b.classList.toggle('is-end', window.innerHeight + window.scrollY > document.documentElement.scrollHeight - 140);
    }, { passive: true });
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }
})();

// Spark 1.1 · aparitie la scroll, numere care cresc ([data-spark-count]) si bara de urgenta (.spark-sb)
(function sparkReveal() {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.spark-sb').forEach(function (el) { el.classList.add('is-in'); });
    return;
  }
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function count(el) {
    if (el.dataset.counted) return;
    el.dataset.counted = '1';
    var m = (el.textContent || '').trim().match(/^(\D*?)(\d[\d.,]*)(.*)$/);
    if (!m || reduce) return;
    var raw = m[2], dec = (raw.split('.')[1] || '').length, to = parseFloat(raw.replace(/,/g, ''));
    if (!isFinite(to) || to === 0) return;
    var start = null, dur = 1400;
    function fmt(v) { return m[1] + (dec ? v.toFixed(dec) : Math.round(v).toLocaleString('en-US')) + m[3]; }
    el.textContent = fmt(0);
    function tick(ts) {
      if (!start) start = ts;
      var k = Math.min(1, (ts - start) / dur), e = 1 - Math.pow(1 - k, 3);
      el.textContent = fmt(to * e);
      if (k < 1) requestAnimationFrame(tick); else el.textContent = m[1] + raw + m[3];
    }
    requestAnimationFrame(tick);
  }

  var once = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      once.unobserve(e.target);
      if (e.target.hasAttribute('data-spark-count')) count(e.target); else e.target.classList.add('is-in');
    });
  }, { threshold: 0.3 });
  function watch(root) {
    (root || document).querySelectorAll('[data-spark-count]:not([data-counted]), .spark-sb:not(.is-in)').forEach(function (el) { once.observe(el); });
  }
  watch();
  document.addEventListener('shopify:section:load', function (e) { watch(e.target); });

  if (!document.body.classList.contains('spark-anim') || reduce) return;
  var step = +(document.body.dataset.animStep || 80);
  var SEL = 'h2, .rvw__k, .sps3__k, .sptr__k, .spsp__k, .spark-hero__k, .spark-vid__k, .spst__s, .spugc__s, .sptr__p, .spsp__p, .spsp__pts, .spsp__btn, .spsp__media, .spst__c, .spugc__card, .rvw__c, .spark-ba__pics, .spark-ba__txt, .spcmp__t, .spbox__img, .spbox__list li, .spark-faq details, .spark-faq__ask, .pdp-rev__top, .sps3__media, .sps3__big, .sps3__tile, .sps3__btn, .sps3__trust, .sptr__card, .spct__a, .sppr__row, .spark-vid__f, .spark-gallery, .spark-info > *, .spark-hero__content > *, .spt__h, .spt__s';
  var io = new IntersectionObserver(function (es) {
    var i = 0;
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      e.target.style.setProperty('--sp-d', Math.min(i++ * step, 700) + 'ms');
      e.target.classList.add('is-in');
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('#MainContent > .shopify-section').forEach(function (sec) {
    var all = [].slice.call(sec.querySelectorAll(SEL));
    var items = all.filter(function (el) {
      return !all.some(function (o) { return o !== el && o.contains(el); });
    }).slice(0, 18);
    if (!items.length && sec.firstElementChild) items = [sec.firstElementChild];
    items.forEach(function (el) { el.classList.add('sp-a'); io.observe(el); });
  });
  // in editorul temei: sectiunile reincarcate apar direct
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.sp-a').forEach(function (el) { el.classList.add('is-in'); });
  });
})();

// Spark 1.1 · Protectie continut: fara click dreapta, copiere, taiere si tras de poze (campurile de scris raman normale)
(function () {
  var b = document.body;
  if (!b || !b.classList.contains('spark-protect')) return;
  function free(t) { return t && t.closest && t.closest('input, textarea, select, [contenteditable="true"], .sppop__code, [data-allow-copy]'); }
  ['contextmenu', 'copy', 'cut', 'dragstart', 'selectstart'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { if (!free(e.target)) e.preventDefault(); }, true);
  });
  document.addEventListener('keydown', function (e) {
    var k = (e.key || '').toLowerCase();
    if ((e.ctrlKey || e.metaKey) && (k === 's' || k === 'u' || ((k === 'c' || k === 'a' || k === 'x') && !free(e.target)))) e.preventDefault();
  }, true);
})();

// Spark 1.1 · limba dupa tara (Theme settings > Spark · Limba). O singura data per vizitator, fara roboti.
(function () {
  var f = document.getElementById('spark-lang-form');
  if (!f || !window.sparkCountry) return;
  var KEY = 'sparkLangAuto';
  try { if (localStorage.getItem(KEY)) return; } catch (e) { return; }
  if (/bot|crawl|spider|slurp|lighthouse|preview/i.test(navigator.userAgent) || navigator.webdriver) return;
  // vizitatorul care alege singur limba din selector nu mai e mutat niciodata
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.matches && e.target.matches('form[action*="localization"]')) { try { localStorage.setItem(KEY, 'manual'); } catch (x) {} }
  }, true);
  var list = (f.dataset.countries || '').toUpperCase().split(/[\s,]+/).filter(Boolean);
  window.sparkCountry.then(function (c) {
    try { localStorage.setItem(KEY, c || '-'); } catch (e) { return; }
    if (!c || list.indexOf(String(c).toUpperCase()) < 0 || f.dataset.cur === f.dataset.target) return;
    var r = f.querySelector('[name="return_to"]');
    if (r) r.value = location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/i, '') + location.search + location.hash || '/';
    f.submit();
  });
})();

// Spark 1.1g · un link spre produsul care e deja pe pagina (Spark · produs) nu pleaca: deruleaza la bundle
(function sparkBuyScroll() {
  function handleOf(url) {
    var m = url.pathname.match(/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/products\/([^\/?#]+)\/?$/i);
    return m ? decodeURIComponent(m[1]).toLowerCase() : null;
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href]');
    if (!a || a.target === '_blank' || a.closest('cart-drawer, .spark-col, .spark-hbtn')) return;
    var url;
    try { url = new URL(a.getAttribute('href'), location.href); } catch (err) { return; }
    var sec = null;
    if (url.hash === '#buy' && url.pathname === location.pathname) {
      sec = document.querySelector('.spark-product');
    } else if (url.origin === location.origin) {
      var h = handleOf(url);
      if (h) sec = document.querySelector('.spark-product[data-handle="' + h.replace(/"/g, '') + '"]');
    }
    if (!sec) return;
    var t = sec.querySelector('[data-bundle]') || sec.querySelector('[data-add]') || sec;
    e.preventDefault();
    var head = document.querySelector('.shopify-section-header-sticky');
    var off = (head && head.getBoundingClientRect().bottom > 0 ? head.offsetHeight : 0) + 16;
    window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - off, behavior: 'smooth' });
    if (t.matches('[data-bundle]')) {
      t.classList.remove('is-ping');
      setTimeout(function () { t.classList.add('is-ping'); }, 450);
      setTimeout(function () { t.classList.remove('is-ping'); }, 2600);
    }
  });
})();

